export default __webpack_public_path__ + "static/cli_phillip-6175e4b7bfa5552b8c66816877460ad2.png";